/**
 * TanStack Query hooks for `deterministic-ctv-capi-s2s-for-ctv-conversions`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	deterministicCtvCapiS2sForCtvConversionsQueryKeys,
	type CreateDeterministicCtvCapiS2sForCtvConversionsBody,
	type ListDeterministicCtvCapiS2sForCtvConversionsResponse,
	type DeterministicCtvCapiS2sForCtvConversionsRow,
} from "./api";

export function useDeterministicCtvCapiS2sForCtvConversionsList(): UseQueryResult<ListDeterministicCtvCapiS2sForCtvConversionsResponse, Error> {
	return useQuery({
		queryKey: deterministicCtvCapiS2sForCtvConversionsQueryKeys.list(),
		queryFn: list,
	});
}

export function useDeterministicCtvCapiS2sForCtvConversionsCreate(): UseMutationResult<DeterministicCtvCapiS2sForCtvConversionsRow, Error, CreateDeterministicCtvCapiS2sForCtvConversionsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: deterministicCtvCapiS2sForCtvConversionsQueryKeys.all });
		},
	});
}

export function useDeterministicCtvCapiS2sForCtvConversionsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: deterministicCtvCapiS2sForCtvConversionsQueryKeys.all });
		},
	});
}
